export default __webpack_public_path__ + "static/media/fetch_pals_post1.80a7bb2d.jpg";